export default "__VITE_ASSET__DZEJL7dz__"